import { useEffect, useState } from "react";
import { Breadcrumb, BreadcrumbItem, Button, Col, Container, Form, Modal, Nav, Row } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { useGetSalarySheetSummaryMutation } from "../../slices/adminApiSlice";
import { useGetEmployeeListMutation, useGetOptionsMutation } from "../../slices/commonApiSlice";
import { parseOptionsData } from "../../utils/parseOptionsData";
import { parseUserInfo } from "../../utils/parseUtil";

const SalarySheetSummaryScreen = () => {
  const { state } = useLocation();
  const passingData = state?.reportType || "";
  console.log(state, "state");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [empType, setEmpType] = useState("");
  const [empName, setEmpName] = useState("");
  const [department, setDepartment] = useState("");
  const [designation, setDesignation] = useState("");
  const [empCode, setEmpCode] = useState("");
  const [activeType, setActiveType] = useState("0");
  const [language, setLanguage] = useState("0");
  const [showModal, setShowModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [employeeSuggestions, setEmployeeSuggestions] = useState([]);
  const [selectedEmpCode, setSelectedEmpCode] = useState("");
  const [accountCategory, setAccountCategory] = useState("");
  const [reportType, setReportType] = useState("124");
  const [modeOfPay, setModeOfPay] = useState("");
  const [submittedData, setSubmittedData] = useState(null);
  const [reqChkExcel, setReqChkExcel] = useState("");
  const [yearsOptions, setYearsOptions] = useState([]);
  const [excelUrl, setExcelUrl] = useState("");
  const [excelData, setExcelData] = useState("");

  const { userInfo } = useSelector((state) => state.auth);

  const [getSalarySheetSummary, { isLoading }] = useGetSalarySheetSummaryMutation();
  const [getOptions, { isLoading: getOptionsLoading }] = useGetOptionsMutation();
  const [getEmpName, { isLoading: getEmpNameLoading }] = useGetEmployeeListMutation();

  const [employeeTypes, setEmployeeTypes] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    setReportType(passingData);
  }, [passingData]);

  useEffect(() => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;
    const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1;

    const startYear = parseInt(process.env.REACT_APP_START_YEAR, 10 || 2020);

    const options = [];
    for (let i = startYear; i <= currentYear + 1; i++) {
      options.push(i);
    }

    setYearsOptions(options);
    setYear(currentYear.toString());
    setMonth(previousMonth.toString());

    const fetchOptions = async () => {
      try {
        const reqCompanyCode = userInfo[13]?.InfoField || "1";

        const formData = new FormData();
        formData.append("title", "GetEmployeeMasterDataList");
        formData.append("ReqCompanyCode", reqCompanyCode);

        const res = await getOptions(formData);

        const parsedOptions = parseUserInfo(res);
        const parsedData = parseOptionsData(parsedOptions);

        if (parsedData) {
          setEmployeeTypes(parsedData.employeeTypes);
          setDesignations(parsedData.designations);
          setDepartments(parsedData.departments);
        } else {
          toast.error("Failed to load options");
        }
      } catch (err) {
        console.error("Error fetching options:", err);
        toast.error("Error fetching options");
      }
    };

    fetchOptions();
  }, [getOptions, userInfo]);

  const handleEmployeeSearch = async (input) => {
    if (input.length < 3) {
      setEmployeeSuggestions([]);
      return;
    }

    try {
      const reqCompanyCode = userInfo[13]?.InfoField || "1";
      const formData = new FormData();
      formData.append("title", "GetEmployeeList");
      formData.append("ReqCompanyCode", reqCompanyCode);
      formData.append("ReqSearchStr", input);

      const res = await getEmpName(formData);
      const parsedData = parseUserInfo(res);

      if (parsedData && parsedData.length > 0) {
        const employeeList = JSON.parse(parsedData[0].JSONData1);
        setEmployeeSuggestions(employeeList);
      } else {
        setEmployeeSuggestions([]);
        toast.error("No employees found");
      }
    } catch (err) {
      console.error("Error fetching employee list:", err);
      toast.error("Error fetching employee list");
    }
  };

  const handlePrintExcel = async (e) => {
    e.preventDefault();

    const reqCompanyCode = userInfo[13]?.InfoField;
    if (!reportType) {
      toast.warn("Please select a report type");
      return;
    }

    const formData = new FormData();
    formData.append("title", "GetMonthlySalaryReports");
    formData.append("description", "GetMonthlySalaryReports");
    formData.append("ReqRPT_ID", reportType);
    formData.append("ReqYear", year);
    formData.append("ReqMonth", month);
    formData.append("ReqEmpCode", empCode);
    formData.append("ReqCompanyCode", reqCompanyCode);
    formData.append("ReqActiveType", activeType);
    formData.append("REQPAYACCOUNTNAME", "");
    formData.append("ReqPayEmpType", empType);
    formData.append("ReqDepartment", department);
    formData.append("ReqDesig", designation);
    formData.append("ReqChkExcel", 1);

    try {
      // for (let [key, value] of formData.entries()) {
      //     console.log(`${key}: ${value}`, "Hi Data Excel")
      // }
      const res = await getSalarySheetSummary(formData);

      console.log(res, "response");

      const parsedData = parseUserInfo(res);
      const backendUrl = process.env.REACT_APP_URL;

      if (parsedData && Array.isArray(parsedData) && parsedData.length > 0) {
        const data = parsedData[0];

        console.log(data, 3232323);

        if (data.ErrorCode === "0") {
          let filePath = data.JSONData1;

          // if (reqChkExcel === '') {
          if (filePath.startsWith("/api/WebServiceForStaffData.aspx/")) {
            filePath = filePath.replace("/api/WebServiceForStaffData.aspx/", "/");
          }

          const excelUrl = `${backendUrl}${filePath}`;

          const response = await fetch(excelUrl);
          const blob = await response.blob();
          const reader = new FileReader();

          reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const worksheet = workbook.Sheets[workbook.SheetNames[0]];

            const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            setExcelData(excelData);
            setPdfUrl(excelUrl);
            setReqChkExcel(1);
            setShowModal(true);
          };
          reader.readAsArrayBuffer(blob);
          // }
        } else {
          toast.error(data.ErrorMessage || "An error occurred");
        }
      } else {
        toast.error("Failed to parse user info");
      }
    } catch (err) {
      console.error("Error submitting data:", err);
      toast.error(err?.data?.message || "Error submitting data");
    }
  };

  const handlePrintPDF = async (e) => {
    e.preventDefault();

    const reqCompanyCode = userInfo[13]?.InfoField;
    if (!reportType) {
      toast.warn("Please select a report type");
      return;
    }

    const formData = new FormData();
    formData.append("title", "GetMonthlySalaryReports");
    formData.append("description", "GetMonthlySalaryReports");
    formData.append("ReqRPT_ID", reportType);
    formData.append("ReqYear", year);
    formData.append("ReqMonth", month);
    formData.append("ReqEmpCode", empCode);
    formData.append("ReqCompanyCode", reqCompanyCode);
    formData.append("ReqActiveType", activeType);
    formData.append("REQPAYACCOUNTNAME", "");
    formData.append("ReqPayEmpType", empType);
    formData.append("ReqDepartment", department);
    formData.append("ReqDesig", designation);
    formData.append("ReqChkExcel", 0);

    try {
      const res = await getSalarySheetSummary(formData);

      for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`, "Hi Data1");
      }

      const parsedData = parseUserInfo(res);

      if (parsedData && Array.isArray(parsedData) && parsedData.length > 0) {
        const data = parsedData[0];

        if (data.ErrorCode === "0") {
          let pdfPath = data.JSONData1;

          if (pdfPath.startsWith("/api/WebServiceForStaffData.aspx/")) {
            pdfPath = pdfPath.replace("/api/WebServiceForStaffData.aspx/", "/");
          }

          const backendUrl = process.env.REACT_APP_URL;
          const pdfUrl = `${backendUrl}${pdfPath}`;

          setPdfUrl(pdfUrl);
          setShowModal(true);
        } else {
          toast.error(data.ErrorMessage || "An error occurred");
        }
      } else {
        toast.error("Failed to parse user info");
      }
    } catch (err) {
      console.error("Error submitting data:", err);
      toast.error(err?.data?.message || "Error submitting data");
    }
  };

  return (
    <>
      <Breadcrumb>
        <BreadcrumbItem>
          <Nav.Link as={Link} to="/dashboard" className="text-success text-decoration-none">
            Dashboard
          </Nav.Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>Salary Sheet And Summary</BreadcrumbItem>
      </Breadcrumb>
      <Container className="form-container">
        <h4 className="text-center">Salary Sheet And Summary</h4>
        <Form className="border p-4 rounded bg-light mb-4">
          <Row className="mb-3">
            <Col md={12}>
              <Form.Group controlId="empName">
                <Form.Label>Employee Name</Form.Label>
                <Typeahead
                  id="empName-typeahead"
                  onInputChange={(input) => {
                    setEmpName(input);
                    handleEmployeeSearch(input);
                  }}
                  onChange={(selected) => {
                    if (selected.length > 0) {
                      setEmpName(selected[0].EmployeeName);
                      setSelectedEmpCode(selected[0].Empcode); // Save the employee code
                      setEmpCode(selected[0].Empcode);
                    }
                  }}
                  options={employeeSuggestions}
                  labelKey="EmployeeName"
                  placeholder="Choose an employee..."
                  selected={empName ? [{ EmployeeName: empName }] : []}
                  className="form-control-hover"
                  minLength={3}
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="month">
                <Form.Label>Month</Form.Label>
                <Form.Control as="select" value={month} onChange={(e) => setMonth(e.target.value)} className="form-control-hover">
                  <option value="1">January</option>
                  <option value="2">February</option>
                  <option value="3">March</option>
                  <option value="4">April</option>
                  <option value="5">May</option>
                  <option value="6">June</option>
                  <option value="7">July</option>
                  <option value="8">August</option>
                  <option value="9">September</option>
                  <option value="10">October</option>
                  <option value="11">November</option>
                  <option value="12">December</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="year">
                <Form.Label>Year</Form.Label>
                <Form.Control as="select" value={year} onChange={(e) => setYear(e.target.value)} className="form-control-hover" required>
                  {yearsOptions.map((yr) => (
                    <option key={yr} value={yr}>
                      {yr}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group controlId="empCode" className="mb-3">
                <Form.Label>Employee Code</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Employee Code"
                  value={empCode}
                  onChange={(e) => setEmpCode(e.target.value)}
                  className="form-control-hover"
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="department">
                <Form.Label>Department</Form.Label>
                <Typeahead
                  id="department-typeahead"
                  onChange={(selected) => setDepartment(selected[0])}
                  options={departments}
                  placeholder="Choose a department..."
                  selected={department ? [department] : []}
                  className="form-control-hover"
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="empType">
                <Form.Label>Employee Type</Form.Label>
                <Typeahead
                  id="empType-typeahead"
                  onChange={(selected) => setEmpType(selected[0])}
                  options={employeeTypes}
                  placeholder="Choose an employee type..."
                  selected={empType ? [empType] : []}
                  className="form-control-hover"
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="date">
                <Form.Label>Active Type</Form.Label>
                <Form.Control
                  as="select"
                  value={activeType}
                  onChange={(e) => setActiveType(e.target.value)}
                  className="form-control-hover"
                  required
                >
                  <option value="0">All</option>
                  <option value="1">Active</option>
                  <option value="2">Dropped</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="designation">
                <Form.Label>Designation</Form.Label>
                <Typeahead
                  id="designation-typeahead"
                  onChange={(selected) => setDesignation(selected[0])}
                  options={designations}
                  placeholder="Choose a designation..."
                  selected={designation ? [designation] : []}
                  className="form-control-hover"
                />
              </Form.Group>
            </Col>
            <Col className="">
              <Form.Group controlId="modeOfPay">
                <Form.Label>Mode of Pay</Form.Label>
                <Form.Control as="select" value={modeOfPay} onChange={(e) => setModeOfPay(e.target.value)} className="form-control-hover">
                  <option value="">--Select--</option>
                  <option value="0">Cash</option>
                  <option value="1">Bank</option>
                  <option value="2">Cheque</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={12}>
              <Form.Group>
                <Form.Label>
                  <div className="headline">Report Type</div>
                </Form.Label>
                <div className="d-flex justify-content-around">
                  <Form.Check
                    type="radio"
                    id="reportType"
                    name="reportType"
                    label="Salary Sheet"
                    value="124"
                    checked={reportType === "124"}
                    onChange={(e) => setReportType(e.target.value)}
                    className="mx-3"
                  />
                  <Form.Check
                    type="radio"
                    id="reportType"
                    name="reportType"
                    label="Salary Summary"
                    value="152"
                    checked={reportType === "152"}
                    onChange={(e) => setReportType(e.target.value)}
                  />
                  <Form.Check
                    type="radio"
                    id="reportType"
                    name="reportType"
                    label="OT Register"
                    value="162"
                    checked={reportType === "162"}
                    onChange={(e) => setReportType(e.target.value)}
                  />
                  <Form.Check
                    type="radio"
                    id="reportType"
                    name="reportType"
                    label="Incorrect Basic Report"
                    value="189"
                    checked={reportType === "189"}
                    onChange={(e) => setReportType(e.target.value)}
                  />
                </div>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3 text-center">
            {reportType !== "189" && (
              <Col>
                <Button type="button" variant="danger" className="px-4" disabled={isLoading || getOptionsLoading} onClick={handlePrintPDF}>
                  {isLoading || getOptionsLoading ? "Loading..." : "PRINT PDF"}
                </Button>
              </Col>
            )}
            {reportType !== "162" && (
              <Col>
                <Button
                  type="button"
                  variant="success"
                  className="px-4"
                  disabled={isLoading || getOptionsLoading}
                  onClick={handlePrintExcel}
                >
                  {isLoading || getOptionsLoading ? "Loading..." : "PRINT EXCEL"}
                </Button>
              </Col>
            )}
          </Row>
        </Form>

        <Modal show={showModal} onHide={() => setShowModal(false)} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>Salary Sheet And Summary {reqChkExcel}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {console.log("reqChkExcel value:", reqChkExcel)} {/* This will log the value */}
            <div className="text-center mb-3">
              {reqChkExcel === 1 ? (
                <>
                  <Button variant="primary" href={pdfUrl} download>
                    Download Excel {reqChkExcel}
                  </Button>
                  <div style={{ maxHeight: "400px", overflowY: "auto", marginTop: "10px" }}>
                    {excelData ? (
                      <table className="table table-striped table-bordered">
                        <thead>
                          <tr>
                            {excelData[0].map((header, index) => (
                              <th key={index}>{header}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {excelData.slice(1).map((row, rowIndex) => (
                            <tr key={rowIndex}>
                              {row.map((cell, cellIndex) => (
                                <td key={cellIndex}>{cell}</td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <p>No data available</p>
                    )}
                  </div>
                </>
              ) : (
                pdfUrl && <iframe src={pdfUrl} style={{ width: "100%", height: "500px", marginTop: "10px" }} title="PDF Viewer" />
              )}
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default SalarySheetSummaryScreen;
